import React from 'react'

const third = () => {
  return (
    <div className='lg:container mx-auto px-4'>
        <div className='flex justify-center items-center gap-2'>
            <div className='w-14 bg-[#8A8A8A] h-0.5'></div>
            <p className='text-[#674099] text-3xl font-semibold'>What’s New</p>
            <div className='w-14 bg-[#8A8A8A] h-0.5'></div>
        </div>
        <div className='py-10 lg:w-full md:w-4/6 sm:w-5/6 mx-auto'>
            <div className="flex gap-5 mb-4 third-con">
                <div className="card-small lg:w-[24%] w-[48%] lg:flex-0 flex-1 flex flex-col justify-center items-center rounded-lg bg-[#FAF2F0] p-5">
                    <img src={`./bulb-1.png`} className="w-3/5" />
                    <p className='text-[#674099] font-semibold'>35% OFF</p>
                    <p>ECO B22 Bayonet LED</p>
                    <a href="" className='border  border-[#EB4F23] px-4 py-1 rounded-lg text-[#EB4F23] flex items-center gap-1 font-medium mt-4 justify-center'>Buy Now 
                    <span>
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M20 12L20.7071 11.2929L21.4142 12L20.7071 12.7071L20 12ZM5 13C4.44771 13 4 12.5523 4 12C4 11.4477 4.44771 11 5 11V13ZM14.7071 5.29289L20.7071 11.2929L19.2929 12.7071L13.2929 6.70711L14.7071 5.29289ZM20.7071 12.7071L14.7071 18.7071L13.2929 17.2929L19.2929 11.2929L20.7071 12.7071ZM20 13H5V11H20V13Z" fill="#EB4F23"/>
                        </svg>
                    </span>
                    </a>
                </div>
                <div className="card-small lg:w-[24%] w-[48%] lg:flex-0 flex-1 flex flex-col justify-center items-center rounded-lg bg-[#EEF3FE] p-5">
                    <img src={`./bulb-2.png`} className="w-3/5" />
                    <p className='text-[#674099] font-semibold'>35% OFF</p>
                    <p>ECO B22 Bayonet LED</p>
                    <a href="" className='border  border-[#EB4F23] px-4 py-1 rounded-lg text-[#EB4F23] flex items-center gap-1 font-medium mt-4 justify-center'>Buy Now 
                    <span>
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M20 12L20.7071 11.2929L21.4142 12L20.7071 12.7071L20 12ZM5 13C4.44771 13 4 12.5523 4 12C4 11.4477 4.44771 11 5 11V13ZM14.7071 5.29289L20.7071 11.2929L19.2929 12.7071L13.2929 6.70711L14.7071 5.29289ZM20.7071 12.7071L14.7071 18.7071L13.2929 17.2929L19.2929 11.2929L20.7071 12.7071ZM20 13H5V11H20V13Z" fill="#EB4F23"/>
                        </svg>
                    </span>
                    </a>
                </div>
                <div className="card-big lg:w-[52%] w-[100%] flex items-center rounded-lg bg-[#F6F6F6] p-5">
                    <div className='w-2/4'>
                        <p className='text-[#674099] font-semibold text-xl'>67% OFF</p>
                        <p className='text-lg font-semibold text-[#333333]'>SRL 12 W Standard B22 LED Bulb with Free 4 AA Battery (White, Pack of 4)</p>
                        <div className='flex mt-4'>
                            <a href="" className='border  border-[#EB4F23] px-4 py-1 rounded-lg text-[#EB4F23] flex items-center gap-1 font-medium mt-4 justify-center'>Buy Now 
                            <span>
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M20 12L20.7071 11.2929L21.4142 12L20.7071 12.7071L20 12ZM5 13C4.44771 13 4 12.5523 4 12C4 11.4477 4.44771 11 5 11V13ZM14.7071 5.29289L20.7071 11.2929L19.2929 12.7071L13.2929 6.70711L14.7071 5.29289ZM20.7071 12.7071L14.7071 18.7071L13.2929 17.2929L19.2929 11.2929L20.7071 12.7071ZM20 13H5V11H20V13Z" fill="#EB4F23"/>
                                </svg>
                            </span>
                            </a>
                        </div>
                    </div>
                    <div className='w-2/4'>   
                        <img src={`./bulb-3.png`} className="" />
                    </div>
                </div>
            </div>
            <div className="flex gap-5 third-con">
                <div className="card-big lg:w-[52%] w-[100%] flex items-center rounded-lg bg-[#EBF8F0] p-5">
                    <div className='w-2/4'>
                        <p className='text-[#674099] font-semibold text-xl'>80% OFF</p>
                        <p className='text-lg font-semibold text-[#333333]'>SRL 12 W Standard B22 LED Bulb with Free 4 AA Battery (White, Pack of 4)</p>
                        <div className='flex mt-4'>
                            <a href="" className='border  border-[#EB4F23] px-4 py-1 rounded-lg text-[#EB4F23] flex items-center gap-1 font-medium mt-4 justify-center'>Buy Now 
                            <span>
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M20 12L20.7071 11.2929L21.4142 12L20.7071 12.7071L20 12ZM5 13C4.44771 13 4 12.5523 4 12C4 11.4477 4.44771 11 5 11V13ZM14.7071 5.29289L20.7071 11.2929L19.2929 12.7071L13.2929 6.70711L14.7071 5.29289ZM20.7071 12.7071L14.7071 18.7071L13.2929 17.2929L19.2929 11.2929L20.7071 12.7071ZM20 13H5V11H20V13Z" fill="#EB4F23"/>
                                </svg>
                            </span>
                            </a>
                        </div>
                    </div>
                    <div className='w-2/4'>   
                        <img src={`./bulb-4.png`} className="" />
                    </div>
                </div>
                <div className="card-small lg:w-[24%] w-[48%] lg:flex-0 flex-1 flex flex-col justify-center items-center rounded-lg bg-[#FCF6EA] p-5">
                    <img src={`./bulb-5.png`} className="w-3/5" />
                    <p className='text-[#674099] font-semibold'>35% OFF</p>
                    <p>ECO B22 Bayonet LED</p>
                    <a href="" className='border  border-[#EB4F23] px-4 py-1 rounded-lg text-[#EB4F23] flex items-center gap-1 font-medium mt-4 justify-center'>Buy Now 
                    <span>
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M20 12L20.7071 11.2929L21.4142 12L20.7071 12.7071L20 12ZM5 13C4.44771 13 4 12.5523 4 12C4 11.4477 4.44771 11 5 11V13ZM14.7071 5.29289L20.7071 11.2929L19.2929 12.7071L13.2929 6.70711L14.7071 5.29289ZM20.7071 12.7071L14.7071 18.7071L13.2929 17.2929L19.2929 11.2929L20.7071 12.7071ZM20 13H5V11H20V13Z" fill="#EB4F23"/>
                        </svg>
                    </span>
                    </a>
                </div>
                <div className="card-small lg:w-[24%] w-[48%] lg:flex-0 flex-1 flex flex-col justify-center items-center rounded-lg bg-[#FBF5E7] p-5">
                    <img src={`./bulb-6.png`} className="w-4/5" />
                    <p className='text-[#674099] font-semibold'>35% OFF</p>
                    <p>ECO B22 Bayonet LED</p>
                    <a href="" className='border  border-[#EB4F23] px-4 py-1 rounded-lg text-[#EB4F23] flex items-center gap-1 font-medium mt-4 justify-center'>Buy Now 
                    <span>
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M20 12L20.7071 11.2929L21.4142 12L20.7071 12.7071L20 12ZM5 13C4.44771 13 4 12.5523 4 12C4 11.4477 4.44771 11 5 11V13ZM14.7071 5.29289L20.7071 11.2929L19.2929 12.7071L13.2929 6.70711L14.7071 5.29289ZM20.7071 12.7071L14.7071 18.7071L13.2929 17.2929L19.2929 11.2929L20.7071 12.7071ZM20 13H5V11H20V13Z" fill="#EB4F23"/>
                        </svg>
                    </span>
                    </a>
                </div>
            </div>
        </div>
    </div>
  )
}

export default third;
